"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultGetRowKey = defaultGetRowKey;
exports.isGroupData = isGroupData;
exports.calculateOffsets = calculateOffsets;
exports.Wrapper = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _designTokens = require("@decisiv/design-tokens");

var _styledComponentsModifiers = require("styled-components-modifiers");

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultGetRowKey(_ref) {
  var key = _ref.key,
      id = _ref.id;
  return key || id;
}

function isGroupData(dataObj, _ref2) {
  var rowDataPath = _ref2.rowDataPath,
      GroupHeader = _ref2.GroupHeader;

  if (GroupHeader && rowDataPath) {
    return Boolean((0, _get.default)(dataObj, rowDataPath));
  }

  return false;
}

var kindModifiersConfig = {
  primary: function primary() {
    return (0, _styledComponents.css)(["background-color:", ";"], (0, _toColorString.default)(_designTokens.color.base.halfMoon));
  },
  secondary: function secondary() {
    return '';
  }
};
var kindModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)(kindModifiersConfig, 'kind');

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "utils__Wrapper",
  componentId: "sc-1clynby-0"
})(["display:flex;color:", ";font-size:", ";padding:", " ", ";width:100%;", ""], (0, _toColorString.default)(_designTokens.color.base.alaskanHusky), (0, _rem.default)(_designTokens.typography.size.alias.paragraph2), (0, _rem.default)(_designTokens.spacing.base), (0, _rem.default)(_designTokens.spacing.base * 2), kindModifiers);

exports.Wrapper = Wrapper;

function calculateOffsets(columns, columnsWidth) {
  var leftOffset = 0;
  var rightOffset = 0;
  var fixedColumns = {};

  for (var index = 0; index < columns.length; index += 1) {
    var column = columns[index];
    if (!column.fixed) break;
    fixedColumns[column.name] = {
      alignment: 'left',
      offset: leftOffset
    };
    leftOffset += Math.floor(columnsWidth[column.name] || 0);
  }

  for (var _index = columns.length - 1; _index >= 0; _index -= 1) {
    var _column = columns[_index];
    if (!_column.fixed) break;
    fixedColumns[_column.name] = {
      alignment: 'right',
      offset: rightOffset
    };
    rightOffset += Math.floor(columnsWidth[_column.name] || 0);
  }

  return fixedColumns;
}